module.exports = "<p>\n  events-page works!\n</p>\n"